<header-component></header-component> 

<about-component></about-component>

<courses-component></courses-component>

<business-component></business-component>

<footer-component></footer-component>   